const clients = [
	{
	  id: "63392",
	  firstName: "Henry",
	  lastName: "Cooper",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Active",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "High",
	  numberOfContact: 8,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
		{
		  grievanceId: "3240342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
		{
		  grievanceId: "3245322",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
		{
		  grievanceId: "3245442",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
		{
		  grievanceId: "3249342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
		{
		  grievanceId: "3245362",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
		{
		  grievanceId: "3265342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
		{
		  grievanceId: "3265311",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
		{
		  grievanceId: "3265932",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	
		  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "848473",
	  firstName: "Benny",
	  lastName: "Bauer",
	  avatarUrl: "",
	  category: "F&F",
	  phoneNumber: "(406) 555-0120",
	  lastActiveTimeStamp: "",
	  status: "Active",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "High",
	  numberOfContact: 4,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "945096",
	  firstName: "Matt",
	  lastName: "Cooper",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Blocked",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Low",
	  numberOfContact: 7,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "492394",
	  firstName: "Prem",
	  lastName: "Bauer",
	  avatarUrl: "",
	  category: "F&F",
	  phoneNumber: "(406) 555-0332",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 9,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "29417-011",
	  firstName: "Wade",
	  lastName: "Warren",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 5,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "75342",
	  firstName: "Brook",
	  lastName: "Simon",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 4,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "20674-847",
	  firstName: "Guy",
	  lastName: "Hawkins",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 3,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "47392-098",
	  firstName: "Robert",
	  lastName: "Fox",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 6,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "63392-154",
	  firstName: "Cody",
	  lastName: "Fisher",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 7,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "",
	  firstName: "Henry",
	  lastName: "Cooper",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Active",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "High",
	  numberOfContact: 8,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "848473",
	  firstName: "Benny",
	  lastName: "Bauer",
	  avatarUrl: "",
	  category: "F&F",
	  phoneNumber: "(406) 555-0120",
	  lastActiveTimeStamp: "",
	  status: "Active",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "High",
	  numberOfContact: 4,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "945096",
	  firstName: "Matt",
	  lastName: "Cooper",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Blocked",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Low",
	  numberOfContact: 7,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "492394",
	  firstName: "Prem",
	  lastName: "Bauer",
	  avatarUrl: "",
	  category: "F&F",
	  phoneNumber: "(406) 555-0332",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 9,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "29417-011",
	  firstName: "Wade",
	  lastName: "Warren",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 5,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "75342",
	  firstName: "Brook",
	  lastName: "Simon",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 4,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "20674-847",
	  firstName: "Guy",
	  lastName: "Hawkins",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 3,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "47392-098",
	  firstName: "Robert",
	  lastName: "Fox",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 6,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "63392-154",
	  firstName: "Cody",
	  lastName: "Fisher",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 7,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "",
	  firstName: "Henry",
	  lastName: "Cooper",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Active",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "High",
	  numberOfContact: 8,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "848473",
	  firstName: "Benny",
	  lastName: "Bauer",
	  avatarUrl: "",
	  category: "F&F",
	  phoneNumber: "(406) 555-0120",
	  lastActiveTimeStamp: "",
	  status: "Active",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "High",
	  numberOfContact: 4,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "945096",
	  firstName: "Matt",
	  lastName: "Cooper",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Blocked",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Low",
	  numberOfContact: 7,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "492394",
	  firstName: "Prem",
	  lastName: "Bauer",
	  avatarUrl: "",
	  category: "F&F",
	  phoneNumber: "(406) 555-0332",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 9,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "29417-011",
	  firstName: "Wade",
	  lastName: "Warren",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 5,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "75342",
	  firstName: "Brook",
	  lastName: "Simon",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 4,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "20674-847",
	  firstName: "Guy",
	  lastName: "Hawkins",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 3,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "47392-098",
	  firstName: "Robert",
	  lastName: "Fox",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 6,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "63392-154",
	  firstName: "Cody",
	  lastName: "Fisher",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 7,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "33492-766",
	  firstName: "Sav",
	  lastName: "Nguyen",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 4,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
	{
	  id: "83654-572",
	  firstName: "Bess",
	  lastName: "Cooper",
	  avatarUrl: "",
	  category: "Inmate",
	  phoneNumber: "",
	  lastActiveTimeStamp: "",
	  status: "Inactive",
	  facility: "Block B",
	  housingUnit: "Block B",
	  securityThreatGroup: "Medium",
	  numberOfContact: 6,
	  grievances: [
		{
		  grievanceId: "2345855",
		  inmateId: "234234",
		  department: "Security Department",
		  timeRemaining: "4d 1:23h",
		  date: "2020-02-21",
		  status: "Open",
		},
		{
		  grievanceId: "4345832",
		  inmateId: "234234",
		  department: "Medical Department",
		  timeRemaining: "14d 22:23h",
		  date: "2020-02-21",
		  status: "Appeal",
		},
		{
		  grievanceId: "5445855",
		  inmateId: "2342343",
		  department: "Chief Office",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Resolved",
		},
		{
		  grievanceId: "3245342",
		  inmateId: "123123",
		  department: "Medical Department",
		  timeRemaining: "-",
		  date: "2020-02-21",
		  status: "Closed",
		},
	  ],
	  chats: [
		{
		  chatId: "1231",
		  firstName: "Guy",
		  lastName: "Hawkins",
		  phoneNumber: "(406) 555-0120",
		  status: "Open",
		  numberOfChats: 8,
		},
		{
		  chatId: "1232",
		  firstName: "Arlene",
		  lastName: "McCoy",
		  phoneNumber: "(406) 555-0122",
		  status: "Closed",
		  numberOfChats: 8,
		},
		{
		  chatId: "1234",
		  firstName: "Jerome",
		  lastName: "Bell",
		  phoneNumber: "(406) 555-0121",
		  status: "Closed",
		  numberOfChats: 8,
		},
	  ],
	},
  ];

  export default clients